<template>
  <div class="pies">
    <div class="pieEchartsTwo" ref="pie_statistics" style='width:100%;height:100%;'></div>
  </div>
</template>

<script>
import EChart from 'echarts'
export default {
    props:{
        valve:{
            type:[Object,Array],
            default:function(){
              return {}
            }
        }
    },
    data () {
        return {
          pie_statistics:{
              option: {},
              chart: null,
              element: {},

          },
          valveData:{},
          interval: null,
          chartArray:['pie_statistics'],
        }
    },
    mounted() {
    //   that.$nextTick(()=>{
    //               (()=>{
    //         //   that.initData();
    //         that.select_loop();
    //     },200)
    //   });
    // this.onWindowResize();
    // this.$nextTick(()=>{
    //      setTimeout(() => {
            // this.onWindowResize()
    //     },1000);
    // })


    },
    destory(){
        // window.onresize = null;
    },
    beforeDestroy(){
        window.removeEventListener('resize',this.onWindowResize,false);
        window.removeEventListener('resize',this.onchartResize,false);
        if(this.interval){
            clearInterval(this.interval);
        }
    },
    watch:{
         valve:{
            handler:function(newVal,oldVal){
                if(newVal !== oldVal){
                  setTimeout(()=>{
                    this.pageInit();
                  },1000)
                }
            },
            deep:true
        }
    },
    methods: {
        //根据页面调整
        onWindowResize(){
            // let pageHeight = document.documentElement.clientHeight; //页面总高度
            // let pieStyle = document.querySelectorAll(".Summary")[0].clientHeight;
            if(document.querySelectorAll(".left_wrap") && document.querySelectorAll(".left_wrap")[0]){
              let pieStyle = document.querySelectorAll(".left_wrap")[0].clientHeight;
              if(document.querySelectorAll(".pieEchartsTwo") && document.querySelectorAll(".pieEchartsTwo")[0]){
                document.querySelectorAll(".pieEchartsTwo")[0].style.height =  pieStyle - 20 + 'px';
              }
                this.onchartResize();
                if(JSON.stringify(this.valve) !== "{}")this.disposeAllChart();
            }
        },
        //释放图表，销毁对象
        disposeAllChart(){
          let i = 0 , len = this.chartArray.length
          for (;i < len; i++){
            let a = this.chartArray[i]
            if(this[a].chart){
              this[a].chart.dispose()
            }
          }
          this.initData()
        },
        onchartResize(){
            let chartBox = this.pie_statistics.chart;
                var width = chartBox.clientWidth;
                let option = chartBox.getOption();
                if (width) {
                    chartBox.resize();
                    chartBox.setOption(option, true)
                }
        },
        pageInit(){
            this.valveData = this.$deepClone(this.valve);
            this.initData();
            // this.select_loop();

        },
        select_loop(){
            let vue = this;
            let num = 0;
            var len = null;
            if(JSON.stringify(vue.valveData) !== "{}"){
                if(vue.valveData.series_data && vue.valveData.series_data.length){
                    len = vue.valveData.series_data.length;
                }
            }
            if(len){
                this.interval = setInterval(()=>{
                    if(vue.pie_statistics.chart){
                    vue.valveData.series_data.forEach((item,index)=>{
                        let _index = index*1;
                        if(_index == num){
                        vue.pie_statistics.chart.dispatchAction({
                            type: 'pieSelect',
                            seriesIndex:0 ,//第几条series
                            dataIndex: _index,//第几个tooltip
                        });
                        vue.pie_statistics.chart.dispatchAction({
                            type: 'showTip',
                            seriesIndex:0 ,//第几条series
                            dataIndex: _index,//第几个tooltip
                        });
                        }else{
                        vue.pie_statistics.chart.dispatchAction({
                            type: 'pieUnSelect',
                            seriesIndex:0 ,//第几条series
                            dataIndex: _index,//第几个tooltip
                        });
                        }
                    });

                    }
                    num = num + 1;
                    if(num >= len * 1){
                        num = 0
                    }
                },2000)
            }else{
                vue.pie_statistics.chart.dispatchAction({
                    type: 'showTip',
                    seriesIndex:0 ,//第几条series
                    dataIndex: 0,//第几个tooltip
                });
            }
        },
        initData(){
            //    var data = [{
            //         "name": "系统",
            //         "value": 10
            //     }, {
            //         "name": "报警",
            //         "value": 10
            //     }, {
            //         "name": "人工",
            //         "value": 10
            //     }, {
            //         "name": "APP",
            //         "value": 10
            //     }, ]
            if(this.interval){
                clearInterval(this.interval);
            }
            var scale=1;
            var data = this.valveData.series_data;
            console.log('series_data-=-=--=-=-'+JSON.stringify(data))
            this.pie_statistics.option = {
                color: ['#04e0f9', '#eb6100', '#cce198', '#22ac38', '#fb734e', '#e32f46','#94d96c', '#0bbcb7','#1a9bfc','#7049f0'],
            //     title: {
            //       text: '总数',
            //       // subtext: 7789,
            //       textStyle: {
            //           color: '#f2f2f2',
            //           fontSize: 14,
            //           // align: 'center'
            //       },
            //       subtextStyle: {
            //           fontSize: 30,
            //           color: ['#ff9d19']
            //       },
            //       x: 100,
            //       y: 100,
            //   },
              // grid: {
              //     bottom: 150,
              //     left: '100%',
              //     right: '10%'
              // },
                tooltip: {
                    trigger: "item",
                    // formatter: "{a} <br/> {b}:{c}%",
                    formatter: "{b}:{c}%",
                    backgroundColor: 'rgba(0,0,0,0.7)', // 背景
                    padding: [8, 10], //内边距
                    extraCssText: 'box-shadow: 0 0 3px rgba(255, 255, 255, 0.4);', //添加阴影
                },
                legend: {
                  orient: 'vertical',
                  top: "middle",
                  right: "5%",
                  icon: 'roundRect',
                 itemWidth: 12*scale, // 图例图形宽度
                 itemHeight: 12*scale, // 图例图形高度
                  textStyle: {
                      color: '#d3d3d1',
                    //   fontSize: 14,  //大
                    fontSize: 12,

                  },
                  data: data,
                },
                series: [
                // 主要展示层的
                    {
                        // radius: ['30%', '61%'],  //大
                        radius: ['30%', '61%'],
                        center: ['40%', '50%'],
                        type: 'pie',
                        // name: "关阀汇总",
                        label: {
                            normal: {
                                show: false,
                                formatter: "{c}%",
                                textStyle: {
                                    fontSize: 30,

                                },
                                position: 'outside'
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false,
                                length: 30,
                                length2: 55
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        data: data,

                    },
                    // 边框的设置
                    {
                        radius: ['30%', '43%'],
                        center: ['40%', '50%'],
                        type: 'pie',
                        label: {
                            normal: {
                                show: false
                            },
                            emphasis: {
                                show: false
                            }
                        },
                        labelLine: {
                            normal: {
                                show: false
                            },
                            emphasis: {
                                show: false
                            }
                        },
                            itemStyle : {
                        normal : {
                            label : {
                                show : false
                            },
                            labelLine : {
                                show : false
                            }
                            },

                        },
                        animation: false,
                        tooltip: {
                            show: false
                        },
                    },
                    // {
                    //     name: '外边框',
                    //     type: 'pie',
                    //     clockWise: false, //顺时加载
                    //     hoverAnimation: false, //鼠标移入变大
                    //     center: ['40%', '50%'],
                    //     radius: ['65%', '65%'],
                    //     label: {
                    //         normal: {
                    //             show: false
                    //         }
                    //     },
                    //     data: [{
                    //         value: 9,
                    //         name: '',
                    //         itemStyle: {
                    //             normal: {
                    //                 borderWidth: 2,
                    //                 borderColor: '#0b5263'
                    //             }
                    //         }
                    //     }]
                    // },
                ]
            };
            // if(this.pie_statistics.chart!=null&&this.pie_statistics.chart!=''&&this.pie_statistics.chart!=undefined){
            //     this.pie_statistics.chart.dispose();
            // }
            this.pie_statistics.chart = EChart.init(this.$refs.pie_statistics);
            this.pie_statistics.chart.setOption(this.pie_statistics.option);
            window.addEventListener('resize', this.onWindowResize);
            this.select_loop();
        //     this.pie_statistics.chart.resize();
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.pies{
    width: 100%;
    height: 100%;
    .pieEchartsTwo{
        border-right:0;
        border-left: 0;
        width:100%;
        height: 100%;
        z-index:1;
        /* height:260px; */
        /* background-color: red; */
    }
}

</style>



// WEBPACK FOOTER //
// src/components/chart/pie.vue